<template>
  <div class="company--details-upper-tab animated fadeIn">

    <b-card v-if='!buttonsHeaderVisible' class="buttonHeader">
      <b-row>
        <b-button
          @click="onCancel"
          type="button"
          class="btn btn-secondary cancelButton"
          size="sm"
          >
          Cancel
        </b-button>
        <b-button
          @click="onEdit"
          variant="primary"
          type="submit"
          class="btn btn-primary"
          size="sm"
          :disabled="isSaving"
          >
          <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
        </b-button>
      </b-row>
    </b-card>

    <b-row>
      <b-col cols="8">
        <b-row>
          <b-col cols="3">
            <div class="billing-address-container">
              <b-form-group>
                <template v-slot:label>
                  <span>Bill To Address</span>
                  <a class="edit-address-link" @click="onEditAddress(company.billingAddressId, true)">
                    Edit
                  </a>
                </template>
                <b-form-select
                  id="billToAddressSelect"
                  v-model="company.billingAddressId"
                  :plain="true"
                  @change="onBillingAddressChange"
                >
                  <option
                    v-for="(address) in sortSelect(addressesList)"
                    v-bind:key="address.id"
                    v-bind:value="address.id"
                  >
                    {{ address.name }} - {{ address.addressTypeName }}
                  </option>
                </b-form-select>
                <div class="address-description">
                  <b-form-text>{{this.billingAddress.address1}}</b-form-text>
                  <b-form-text>{{this.billingAddress.address2}}</b-form-text>
                  <b-form-text>{{this.billingAddress.address3}}</b-form-text>
                  <b-form-text>{{this.billingAddress.city}} {{billingAddress.state}} {{this.billingAddress.zipCode}}</b-form-text>
                  <b-form-text>{{this.billingAddress.country}}</b-form-text>
                </div>
              </b-form-group>
            </div>
          </b-col>

          <b-col cols="3">
            <b-form-checkbox
              id="same-as-billing"
              class="same-as-billing-checkbox"
              v-model="sameAsBilling"
              :disabled="!company.billingAddressId"
            >Same as billing</b-form-checkbox>
            <div class="address-container">
              <b-form-group>
                <template v-slot:label>
                  <span>Ship To Address</span>
                  <a class="edit-address-link" @click="onEditAddress(company.shippingAddressId, false)" v-if="company.shippingAddressId">
                    Edit
                  </a>
                </template>
                <b-form-select
                  id="billToAddressSelect"
                  v-model="company.shippingAddressId"
                  :plain="true"
                  @change="onShippingAddressChange"
                >
                  <option
                    v-for="(address) in sortSelect(addressesList)"
                    v-bind:key="address.id"
                    v-bind:value="address.id"
                  >
                    {{ address.name }} - {{ address.addressTypeName }}
                  </option>
                </b-form-select>
                <div class="address-description">
                  <b-form-text>{{shippingAddress.address1}}</b-form-text>
                  <b-form-text>{{shippingAddress.address2}}</b-form-text>
                  <b-form-text>{{shippingAddress.address3}}</b-form-text>
                  <b-form-text>{{shippingAddress.city}} {{shippingAddress.state}} {{shippingAddress.zipCode}}</b-form-text>
                  <b-form-text>{{shippingAddress.country}} </b-form-text>
                </div>
              </b-form-group>
            </div>
          </b-col>

          <b-col cols="3">
            <b-row class="form-group">
              <b-col sm="12" md="4">
                <select v-model="showPhone" class="form-control">
                  <option value="1">Phone 1</option>
                  <option value="2">Phone 2</option>
                  <option value="3">Phone 3</option>
                </select>
              </b-col>
              <b-col sm="12" md="8">
                  <div v-show="showPhone==1">
                    <b-input-group>
                      <b-form-input
                        id="phone1-input"
                        class="form-input"
                        v-model="company.phone1"
                        v-model.trim="$v.company.phone1.$model"
                        :class="{ 'has-error': $v.company.phone1.$error }"
                        @blur="$v.company.phone1.$touch()">
                      </b-form-input>

                    </b-input-group>
                </div>
                <div v-show="showPhone==2">
                  <b-input-group>
                    <b-form-input
                      id="phone2-input"
                      class="form-input"
                      v-model="company.phone2"
                      :class="{ 'has-error': $v.company.phone2.$error }"
                      @blur="$v.company.phone2.$touch()">
                    </b-form-input>
                  </b-input-group>
                </div>
                <div v-show="showPhone==3">
                  <b-input-group>
                    <b-form-input
                      id="phone3-input"
                      class="form-input"
                      v-model="company.phone3"
                      :class="{ 'has-error': $v.company.phone3.$error }"
                      @blur="$v.company.phone3.$touch()">
                    </b-form-input>
                  </b-input-group>
                </div>
              </b-col>

            </b-row>

            <b-row class="form-group">
              <b-col md="4">
              <select v-model="showFax" class="form-control">
                <option value="1">Fax 1</option>
                <option value="2">Fax 2</option>
                <option value="3">Fax 3</option>
              </select>
              </b-col>
              <b-col md="8">
                <div v-show="showFax==1">
                  <b-input-group>
                    <b-form-input
                      id="fax1-input"
                      class="form-input"
                      v-model="company.fax1"
                      :class="{ 'has-error': $v.company.fax1.$error }"
                      @blur="$v.company.fax1.$touch()">
                    </b-form-input>
                  </b-input-group>
                </div>
                <div v-show="showFax==2">
                  <b-input-group>
                    <b-form-input
                      id="fax2-input"
                      class="form-input"
                      v-model="company.fax2"
                      :class="{ 'has-error': $v.company.fax2.$error }"
                      @blur="$v.company.fax2.$touch()">
                    </b-form-input>
                  </b-input-group>
                </div>
                <div v-show="showFax==3">
                  <b-input-group>
                    <b-form-input
                      id="fax3-input"
                      class="form-input"
                      v-model="company.fax3"
                      :class="{ 'has-error': $v.company.fax3.$error }"
                      @blur="$v.company.fax3.$touch()">
                    </b-form-input>
                  </b-input-group>
                </div>

              </b-col>

            </b-row>

            <b-row class="form-group">
              <b-col md="4">
              <select v-model="showEmail" class="form-control">
                <option value="1">Email 1</option>
                <option value="2">Email 2</option>
              </select>
              </b-col>
              <b-col md="8">
                <div v-show="showEmail==1">
                  <b-input-group>
                  <b-form-input
                    id="email1-input"
                    class="form-input"
                    v-model="company.email1"
                    :class="{ 'has-error': $v.company.email1.$error }"
                    @blur="$v.company.email1.$touch()">
                  </b-form-input>
                </b-input-group>
                </div>
                <div v-show="showEmail==2">
                  <b-input-group>
                  <b-form-input
                    id="email2-input"
                    class="form-input"
                    v-model="company.email2"
                    :class="{ 'has-error': $v.company.email2.$error }"
                    @blur="$v.company.email2.$touch()">
                  </b-form-input>
                </b-input-group>
                </div>

              </b-col>

            </b-row>
            <b-row class="form-group">
              <b-col md="4" class="col-form-label pt-0">Website:</b-col>
              <b-col md="8">
                <b-input-group>
                  <b-form-input
                  id="webSite-input"
                  class="form-input"
                  v-model="company.webSite"
                  :class="{ 'has-error': $v.company.webSite.$error }"
                  @blur="$v.company.webSite.$touch()"></b-form-input>
                  <b-input-group-append v-if="extraLabelsVisible.web2 == false">
                    <b-button size="sm" variant="primary" @click="addNewLabel('web2')">
                      <i class="fa fa-plus "></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="4" class="col-form-label pt-0">Employees:</b-col>
              <b-col md="8">
                <b-form-input
                type="text"
                class="form-input"
                v-model.trim="company.companySize">
              </b-form-input>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col md="4" class="col-form-label pt-0">Revenue:</b-col>
              <b-col md="8">
                <b-form-input
                type="text"
                class="form-input"
                v-model.trim="company.revenue">
              </b-form-input>
              </b-col>
            </b-row> 
          </b-col>
          <b-col cols="3">
              
            <b-form-group label="Description">
              <b-textarea v-model="company.description" rows="5" />
            </b-form-group> 
            <br/>
            <b-row class="form-group">
              <b-col offset="5">
                <b-button
                  @click="onCancel"
                  type="button"
                  class="btn btn-secondary mr-1"
                  size="sm"
                >
                  Cancel
                </b-button>
                <b-button
                  @click="onEdit"
                  variant="primary"
                  type="submit"
                  class="btn btn-primary ml-1"
                  size="sm"
                  :disabled="isSaving"
                >
                  <i v-if="isSaving" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>Save
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <edit-address 
          :hideAddButton="true" 
          :companyId="companyId" 
          :id="activeAddressId" 
          ref="editModal" 
          @hideModal="onResetAddressVariables"
          @saved="onSaveEditedAddress">
        </edit-address>
      </b-col>
      
      <b-col cols="4">
        <notes :notes="notes" :canAddNote="checkClaim(CAN_ADD_COMPANY_NOTE)" :canDeleteNote="checkClaim(CAN_DELETE_COMPANY_NOTE)" :canEditNote="checkClaim(CAN_EDIT_COMPANY_NOTE)"
           @add="handleAddNote" @delete="handleDeleteNote" @edit="handleEditNote" />
      </b-col>
    </b-row>
      <hr />
    <b-row >
      <b-col md="12" v-if="isMainLoaded">
        <lower-tab
          :companyId="companyId"
          :companyName="company.name"
          :isVendor="isVendor"
          :isCustomer="isCustomer"
          :isTestHouse="isTestHouse"
        >
        </lower-tab>
      </b-col>
      <b-col v-else>
        <b-alert variant="info" show style="text-align: center">
          <strong> <i class="fa fa-spinner fa-pulse fa-fw mr-1"></i> Loading tabs</strong>
        </b-alert>
      </b-col>     
    </b-row>
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import { date } from '@/shared/filters';
import CompanyEditDto from '@/pages/Company/components/EditCompany/dto';
import AddressDto from '../Addresses/dto';
import { AccountNoteService } from '@/resources';
import LowerTab from '@/pages/Company/components/CompanyDetails/components/LowerTab/index';
import EditAddress from '../Addresses/components/EditAddress/index';

import {
  phoneValidator,
  faxValidator,
  emailValidator,
  webValidator}
  from '@/shared/validators';

import { createScroll, destroyScroll, isElementInView } from '@/shared/scroll'

const additionalFields = [
  { field: 'phone3', precedingField: 'phone2' },
  { field: 'phone2', precedingField: 'phone1' },
  { field: 'fax2', precedingField: 'fax1' },
  { field: 'fax3', precedingField: 'fax2' },
  { field: 'email2', precedingField: 'email1' },
];

export default {
  name: 'DetailsUpperTab',
  components: {
    LowerTab,
    EditAddress,
  },
  computed: {
    ...mapGetters('companies', ['companyById']),
    company() {
      return this.companyById(this.companyId);
    },
    ...mapGetters('address', ['addressesList']),
    companyId() {
      return this.$route.params.id
    },
    isVendor() {
      return (this.company.account_AccountTypes != undefined) ? this.company.account_AccountTypes.filter(x => x.accountTypeId == 3).length > 0 : false;
    },
    isCustomer() {
      return (this.company.account_AccountTypes != undefined) ? this.company.account_AccountTypes.filter(x => x.accountTypeId == 1).length > 0 : false;
    },
    isTestHouse() {
      return this.isVendor && this.company.vendorTypeId == 1497;
    }
  },
  filters: {
    date,
  },
  methods: {
    ...mapActions('address', ['getAddresses', 'getAddressById']),
    ...mapActions('companies', ['getById', 'update']),

    async onBillingAddressChange(value) {
      this.company.billingAddressId = value;
      this.billingAddress = await this.getAddressById(value);
    },
    async onShippingAddressChange(value) {
      this.company.shippingAddressId = value;
      this.shippingAddress = await this.getAddressById(value);
    },

    onEditAddress(id, isBilling) {
      this.activeAddressId = id;
      this.onEditAddressType = (isBilling) ? 'Billing' : 'Shipping';
      this.$bvModal.show('edit-address-modal');
    },

    async onSaveEditedAddress() {
      let updatedAddress = await this.getAddressById(this.activeAddressId);
      console.log(this.onEditAddressType)

      if (this.sameAsBilling) {
        this.billingAddress = updatedAddress;
        this.shippingAddress = updatedAddress
      } 
      else if (this.onEditAddressType == 'Billing') {
        this.billingAddress = updatedAddress;
      }
      else if (this.onEditAddressType == 'Shipping') {
        this.shippingAddress = updatedAddress;
      }

      this.onResetAddressVariables();
      this.onEditAddressType = null;
    },

    onResetAddressVariables() {
      this.activeAddressId = 0;
      // this.onEditAddressType = null;
    },

    addNewLabel(index)
    {
      this.extraLabelsVisible[index] = true;
    },

    removeThisLabel(index)
    {
      this.extraLabelsVisible[index] = false;
    },

    onEdit() {
      this.$v.company.$touch();

      if (this.$v.company.$invalid) {
        this.openAlertBox({message: 'The entered data is incorrect. Enter new correct data'});
        return;
      }
      this.validateExtraLabels();
      var data = new CompanyEditDto(this.company);
      try {
        this.isSaving = true;
        this.update({id: this.company.id, company: data}).then(() => {
          this.onClear();
          this.isSaving = false;
          this.$snotify.success('Company Details saved', 'Company Details');
        });
      } catch (e) {
        this.isSaving = false;
        /*console.log(e.message);*/
      }
    },

    onClear() {
      this.getById(this.company.id);
      this.visibleExtraLabels();
    },

    onCancel() {
      this.$router.push({
        name: 'company.list',
      });
    },

    async handleAddNote(note) {
      await AccountNoteService.create(this.companyId, note);  
      await this.loadNotes();
      this.$snotify.success('New note added', 'Contact Note');
    },

    async handleEditNote(note) {
      if (note.id > 0 && note.accountId == this.companyId) {
        await AccountNoteService.update(note.id, note);
        await this.loadNotes();
        this.$snotify.success('Note updated', 'Contact Note');
      }
    },

    async handleDeleteNote(note) {
      await AccountNoteService.deleteNote(note);
      await this.loadNotes();
      this.$snotify.success('Note deleted', 'Contact Note');
    },

    async loadNotes() {
      this.notes = (this.companyId != undefined) ? await AccountNoteService.getAll(this.companyId) : [];
    },

    visibleExtraLabels(){
      additionalFields.forEach(item => {
        if (this.company[item.field]) {
          this.extraLabelsVisible[item.field] = true;
        } else {
          this.extraLabelsVisible[item.field] = false;
        }
      });
    },
    validateExtraLabels(){
      additionalFields.forEach(item => {
        if (!this.company[item.precedingField]) {
          this.company[item.precedingField] = this.company[item.field];
          this.company[item.field] = '';
        }
      });
      additionalFields.forEach(item => {
        if (!this.company[item.precedingField]) {
          this.company[item.precedingField] = this.company[item.field];
          this.company[item.field] = '';
        }
      });
    },
    setEmptyValuesForHiddenExtraLabels() {
      additionalFields.forEach(item => {
        if (!this.extraLabelsVisible[item.field]) {
          this.company[item.field] = '';
        }
      });
    },
    handleScroll () {
      this.buttonsHeaderVisible = isElementInView(document.getElementById('buttonHeader'));
    },
    // routeLowerTab() {
    //   let lowerTabRedirect = 'company.details.requirements';
    //   if (this.isVendor && !this.isCustomer) {
    //     lowerTabRedirect = 'company.details.offers';
    //   } else if (!this.isVendor && !this.isCustomer) {
    //     lowerTabRedirect = 'company.details.orderfulfillment';
    //   }

    //   this.$router.push({
    //     name: lowerTabRedirect,
    //     params: {id: this.companyId, companyId: this.companyId }
    //   })
    // }
  },
  validations: {
    company: {
      phone1: { phoneValidator },
      phone2: { phoneValidator },
      phone3: { phoneValidator },
      fax1: { faxValidator },
      fax2: { faxValidator },
      fax3: { faxValidator },
      email1: { emailValidator },
      email2: { emailValidator },
      webSite: { webValidator },
    },
  },
  data() {
    return {
      billingAddress: {},
      shippingAddress: {},
      extraLabelsVisible: {
        phone2: false,
        phone3: false,
        email2: false,
        fax2: false,
        fax3: false,
      },
      notes: [],
      newNoteMessage: '',
      sameAsBilling: false,
      buttonsHeaderVisible: true,
      showPhone: 1,
      showFax: 1,
      showEmail: 1,
      isSaving:false,
      activeAddressId: 0,
      onEditAddressType: 'Billing',
      isMainLoaded: false
    };
  },
  watch: {
    sameAsBilling: async function (val) {
      if (val) {
        this.company.shippingAddressId = this.company.billingAddressId;
        this.shippingAddress = await this.getAddressById(this.company.shippingAddressId);
      }
    },
    companyId: async function() {
      await this.loadNotes();
    },
  },
  async mounted() {
    // this.$root.$on('bv::modal::hide', () => {
    //   this.visibleExtraLabels();
    // })
    // await this.getById(this.companyId);
    
    const data = await this.getAddresses(this.companyId);
    this.isMainLoaded = true;
    if(this.company.billingAddressId){
      // this.billingAddress = new AddressDto(data.find(q => q.id == this.company.billingAddressId));
      this.billingAddress = data.find(q => q.id == this.company.billingAddressId);
      console.log(this.billingAddress, "Billing Address")
    }
    if (this.company.shippingAddressId) {
      // this.shippingAddress = new AddressDto(data.find(q => q.id == this.company.shippingAddressId));
      this.shippingAddress = data.find(q => q.id == this.company.shippingAddressId);
      console.log(this.billingAddress, "SHipping Address")
    }

    this.visibleExtraLabels();
    this.loadNotes();
    // this.routeLowerTab();
  },
  // destroyed() {
  //   destroyScroll(this);
  // },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_colors.scss';
.company--details-upper-tab {
  #my-textarea {
    height: 100%;
    width: 100%;
    text-align: left;
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;

    .btn {
      margin-left: 10px;
    }
  }

  .last-note-body {
    background: #f0f3f5;
  }

  .modal-content .error-content {
    color: #cc0000;
  }

  .modal-content .has-error {
    border: 1px solid #cc0000;
    border-radius: 5px;
  }

  .has-error {
    border: 1px solid red;
    border-radius: 5px;
  }

  .same-as-billing-checkbox {
    height: 32px;
  }

  .billing-address-container {
    margin-top: 32px;
  }

  .form-text {
    font-size: 13px;
  }

  .address-description {
    margin-top: 12px;
  }

  .details-title {
    color: $mutedGray;
    font-weight: bold;
    font-size: 16px;
    margin-left: 15px;
  }

  .buttonHeader {
    position: fixed;
    top: 15%;
    left: 60%;
    z-index: 7;
  }

  .cancelButton {
    margin-right: 10px;
  }

  .edit-address-link {
    color: #20a8d8 !important;
    font-size: 80%;
    font-weight: 700;
    padding-bottom: 1px;
    right:20px; 
    top: 35px; 
    position:absolute
  }

  .edit-address-link:hover {
    color: #167495 !important;
    text-decoration: underline !important;
    cursor: pointer;
  }
}
</style>
